// extracted by mini-css-extract-plugin
module.exports = {"inputbox":"Sudoku_inputbox__Uc3PI","sodukobody":"Sudoku_sodukobody__6fwIZ","textarea":"Sudoku_textarea__2AMwe"};